module.exports = __webpack_public_path__ + "static/media/user-home-symbolic.73bfc16f.svg";